import React, { useEffect, useState, useRef } from 'react';
import closeIcon from '../images/close-line-white.svg';
import './NotificationBanner.css';

const NotificationBanner = ({ message, onClose }) => {
  const [exiting, setExiting] = useState(false);
  const [dragging, setDragging] = useState(false);
  const [dragStartY, setDragStartY] = useState(0);
  const [dragOffsetY, setDragOffsetY] = useState(0);
  const bannerRef = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      handleClose();
    }, 6000);

    return () => clearTimeout(timer);
  }, [onClose]);

  const handleClose = (e) => {
    // Prevent any dragging interference with close button click
    if (e) {
      e.stopPropagation();
    }
    setExiting(true);
    setTimeout(onClose, 500); // Match the animation duration with slide-out
  };

  const handleDragStart = (e) => {
    setDragging(true);
    setDragStartY(e.touches ? e.touches[0].clientY : e.clientY);
  };

  const handleDragMove = (e) => {
    e.preventDefault(); // Ensure default behavior is prevented
    if (!dragging) return;

    const currentY = e.touches ? e.touches[0].clientY : e.clientY;
    const offset = currentY - dragStartY;

    if (offset > 0) {
      setDragOffsetY(offset);
    }
  };

  const handleDragEnd = () => {
    if (dragOffsetY > 50) {
      handleClose();
    } else {
      setDragging(false);
      setDragOffsetY(0);
    }
  };

  useEffect(() => {
    const bannerElement = bannerRef.current;

    // Add custom event listeners for touch events with passive: false
    bannerElement.addEventListener('touchstart', handleDragStart, {
      passive: false,
    });
    bannerElement.addEventListener('touchmove', handleDragMove, {
      passive: false,
    });
    bannerElement.addEventListener('touchend', handleDragEnd);

    // Cleanup event listeners on component unmount
    return () => {
      bannerElement.removeEventListener('touchstart', handleDragStart);
      bannerElement.removeEventListener('touchmove', handleDragMove);
      bannerElement.removeEventListener('touchend', handleDragEnd);
    };
  }, [dragging, dragStartY, dragOffsetY]);

  return (
    <div
      ref={bannerRef}
      className={`notification-banner-wrapper ${exiting ? 'slide-out' : ''}`}
    >
      <div
        onMouseDown={handleDragStart}
        onMouseMove={dragging ? handleDragMove : null}
        onMouseUp={handleDragEnd}
        onMouseLeave={dragging ? handleDragEnd : null}
        className="notification-banner"
        style={{
          transform: `translateY(${dragOffsetY}px)`,
          transition: dragging ? 'none' : 'transform 0.3s ease',
        }}
      >
        <div>{message}</div>
        <button onClick={handleClose} className="close-button">
          <img src={closeIcon} width={20} height={20} alt="Close icon" />
        </button>
      </div>
    </div>
  );
};

export default NotificationBanner;
